<template>
    <b-container float>
        <b-row class="vh-100 text-center" align-v="center" align-h="center">
            <b-col md="6">
                <b-card bg-variant="light">
                    <b-card-body class="px-lg-5 py-lg-1">
                        <div class="text-center text-muted mb-4">
                            <h1 class="display-1">OMS</h1>
                        </div>
                        <div class="text-center text-muted mb-4">
                            <small>Sign in with credentials</small>
                        </div>
                        <b-alert variant="danger" :show="!!signInError"
                            >Email or Password invalid</b-alert
                        >

                        <b-form>
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <b-icon icon="envelope-fill"></b-icon>
                                    </b-input-group-text>
                                </b-input-group-prepend>

                                <b-form-input
                                    placeholder="Email"
                                    v-model="model.email"
                                    type="text"
                                ></b-form-input>
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <b-icon icon="lock-fill"></b-icon>
                                    </b-input-group-text>
                                </b-input-group-prepend>

                                <b-form-input
                                    placeholder="Password"
                                    v-model="model.password"
                                    type="password"
                                ></b-form-input>
                            </b-input-group>

                            <div>
                                <router-link to="/forgot_password">
                                    <small>forgot your password?</small>
                                </router-link>
                            </div>
                            <div class="text-right">
                                <b-button
                                    class="my-4"
                                    variant="primary"
                                    :disabled="signingIn ? true : false"
                                    @click="login()"
                                    >{{
                                        signingIn ? 'Signing In' : 'Sign In'
                                    }}</b-button
                                >
                            </div>
                        </b-form>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    name: 'login',
    data() {
        return {
            signingIn: false,
            signInError: false,
            model: {
                email: '',
                password: '',
            },
        }
    },
    methods: {
        login() {
            this.signingIn = true
            this.$store
                .dispatch('login', {
                    email: this.model.email,
                    password: this.model.password,
                })
                .then(() => {
                    // route to dashboard
                    this.$router.push('dashboard')
                })
                .catch(error => {
                    // show error
                    console.log(error)
                    this.signInError = true
                })
                .finally(() => {
                    this.signingIn = false
                })
        },
    },
}
</script>
<style>
</style>
